import axios from "axios";
import alert from "@/common/helper/alert.helper";

class BaseAuth {
  constructor() {
    // const baseURL = env base url
    const baseURL = process.env.VUE_APP_EMS;
    this.http = axios.create({
      baseURL,
    });
    this.http.interceptors.response.use(
      this.handleSuccessResponse,
      this.handleErrorResponse
    );
  }

  handleSuccessResponse(response) {
    return response.data;
  }

  handleErrorResponse(error) {
    if (error.response) {
      const status = error.response.status || error.response.data?.status;
      
      if (status === 401) {
        if (!window.isLoggingOut) {
          window.isLoggingOut = true;
          alert.breaksession();
        }
        return Promise.reject(error);
      }
      else if (status === 500) {
        alert.failed();
      }
    }
    
    throw error;
  }

  get(url, config) {
    return this.http.get(url, config);
  }

  post(url, data, config) {
    return this.http.post(url, data, config);
  }

  put(url, data, config) {
    return this.http.put(url, data, config);
  }

  delete(url, config) {
    return this.http.delete(url, config);
  }
  postLogin(url, data, token) {
    const username = token.email;
    const password = token.password;
    const basicAuth = "Basic " + btoa(username + ":" + password);
    const headers = {
      headers: { Authorization: basicAuth, "Content-Type": "application/json" },
    };

    return this.http.post(url, data, headers);
  }
}

export default BaseAuth;
